export const GOOGLE_CLIENT_KEY = '6Ler770UAAAAAPyTneE-2QnsrEIjqQ4wfnUd-cts';
